import { Box, FlexGrid, Paragraph } from '@telus-uds/components-web'

import Heading from '../../../../siteBuilder/blocks/core/Heading/Heading'

import BBImage from '../../Image'
import { Asset } from 'contentful'

import useBBViewport from '@/hooks/useBBViewport'
import { BannerContainer, BannerWrapper, TextWrapper } from './styles'

export type StoryHeroBannerProps = {
  title: string
  description: string
  image: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>['fields'] | undefined
  mobileImage: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>['fields'] | undefined
}

const HeroBanner = ({ title, description, image, mobileImage }: StoryHeroBannerProps) => {
  const viewport = useBBViewport()

  const src = ['xs', 'sm'].includes(viewport) ? mobileImage : image

  const imageObject = {
    height: src?.file?.details?.image?.height,
    width: src?.file?.details?.image?.width,
    url: src?.file?.url,
    imageAltText: src?.description,
  }

  const hasImage = src?.file?.url ? true : false

  return (
    <BannerContainer data-testid="bb-hero-banner">
      <FlexGrid gutter={false}>
        <FlexGrid.Row verticalAlign="middle" horizontalAlign="center">
          <FlexGrid.Col horizontalAlign="center">
            <BannerWrapper image={src}>
              {src ? (
                <BBImage
                  priority
                  src={imageObject.url}
                  blurDataURL={imageObject.url}
                  alt={imageObject.imageAltText}
                  width={imageObject.width}
                  height={imageObject.height}
                  placeholder="blur"
                  data-testid="bb-hero-banner-image"
                />
              ) : null}
              <TextWrapper hasImage={hasImage} data-testid="hero-banner-text-wrapper">
                <Heading heading="h1" size="h1" text={title} />
                <Paragraph variant={{ size: 'large' }}>{description}</Paragraph>
              </TextWrapper>
            </BannerWrapper>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </BannerContainer>
  )
}

export default HeroBanner
